import { FC, memo } from 'react';

import { dom } from 'app/utils';
import { IComponent } from '../types';
import { Icon } from './icon';

export interface ILabel extends IComponent {
  text: string;
  icon?: string;
}

export const Label: FC<ILabel> = memo(({ id, className, style, text, icon }) => {
  const label: any = { id, style,
    className: dom.className('i-component', 'i-label', className),
  };

  return (
    <label { ...label }>
      {icon && <Icon name={icon} className={[ 'p-button-icon p-c p-button-icon-left', { 'mr-3': text } ]} />}
      <span>{ text }</span>
    </label>
  );
});
